import { BoxWithImages, Breakpoint, Color, FontWeight, Markdown, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { ImageWrapperProps, StyledBoxWithImagesProps } from './centeredSlide.types';

export const StyledBoxWithImages = styled(BoxWithImages)<StyledBoxWithImagesProps>`
  flex: 1 1 100px;
  ${({ $withDoubleImage }: StyledBoxWithImagesProps): string | false => !!$withDoubleImage && 'margin-bottom: 80px'};
`;

export const Wrapper = styled.div`
  width: 100%;
  min-height: 499px;
  padding: 0 16px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${Breakpoint.SmallDesktop} {
    padding: 0 80px 80px;
    gap: 40px;

    &:has(${StyledBoxWithImages}) {
      padding: 0 80px 0;
    }
  }
`;

export const HeadersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin: 20px 0;
`;

export const TextWrapper = styled.div`
  text-align: center;
`;

export const BrandHeader = styled(Typography)`
  color: ${Color.Brand100};
`;

export const ImageWrapper = styled.div<ImageWrapperProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 35px;
  text-align: center;
  ${({ $isWideImage }: ImageWrapperProps): string | false => !$isWideImage && 'max-width: 620px'};
`;

export const Image = styled.img`
  width: 100%;
`;

export const CenteredTextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CenteredTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CenteredTextContent = styled(Markdown)`
  display: flex;
  flex-direction: column;

  em {
    color: ${Color.Brand300};
    font-weight: ${FontWeight.Bold};
    font-style: normal;
  }
`;

export const TextBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const TextBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Color.LightTurquoise};
  padding: 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 40px 20px;
    flex: 1 1 300px;
    text-align: center;
  }
`;

export const DoubleCenteredTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    gap: 40px;
  }
`;

export const DoubleCenteredTextContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
    gap: 40px;
  }
`;

export const DoubleCenteredTextBox = styled.div`
  width: 100%;
  text-align: center;
  padding: 24px 16px;
  background-color: ${Color.White};
`;

export const DoubleCenteredTextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const DoubleCenteredTextContent = styled(Markdown)`
  display: flex;
  flex-direction: column;
`;

export const DoubleCenteredTextBoxText = styled(Markdown)`
  display: flex;
  justify-content: center;

  em {
    font-weight: ${FontWeight.Bold};
    color: ${Color.Brand100};
    font-style: normal;
  }
`;

export const ListItem = styled.li``;

export const List = styled.ul`
  list-style-type: disc;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${ListItem}::marker {
    color: ${Color.Brand100};
    font-size: 16px;
  }

  @media ${Breakpoint.SmallDesktop} {
    gap: 24px;
  }
`;

export const StyledMarkdown = styled(Markdown)`
  em {
    color: ${Color.Brand100};
    font-weight: ${FontWeight.Bold};
    font-style: normal;
  }
`;

export const DefinitionCardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  padding-bottom: 50px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
    padding-bottom: 0;
  }
`;

export const InfoPairWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const InfoPairContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
    gap: 10px;
  }
`;

export const InfoPairTextBox = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: ${Color.White};

  @media ${Breakpoint.SmallDesktop} {
    padding: 20px;
  }
`;

export const TextGridWrapper = styled.div`
  width: 100%;
  margin-top: 24px;

  @media ${Breakpoint.SmallDesktop} {
    margin-top: 0;
  }
`;
